exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option {\n  display: flex;\n  align-items: center;\n}\n.modal-footer {\n  padding: 15px;\n  border-top: 0px solid #e5e5e5;\n  border-top-width: 0;\n}\n.pt-10 {\n  padding-top: 10px;\n}\n", ""]);

// exports
